export enum RelatorioInternoEnum {
  LICITACAO_ATA = 'LICITACAO_ATA',
  CONTRATO = 'CONTRATO',
  PROCESSO_ADMINISTRATIVO = 'PROCESSO_ADMINISTRATIVO',
  PEDIDO_COMPRA = 'PEDIDO_COMPRA',
  SOLICITACAO = 'SOLICITACAO',
  TOMBAMENTO = 'TOMBAMENTO',
  ADITIVO = 'ADITIVO',
  ANEXO = 'ANEXO',
  COTACAO = 'COTACAO',
  LISTA_COMPRA = 'LISTA_COMPRA',
  AUTORIZACAO_FORNECIMENTO = 'AUTORIZACAO_FORNECIMENTO',
  TRANSFERENCIA = 'TRANSFERENCIA',
  MOVIMENTACAO = 'MOVIMENTACAO',
  MANUTENCAO = 'MANUTENCAO',
  INVENTARIO = 'INVENTARIO',
  MOVIMENTACAO_CADASTRAL = 'MOVIMENTACAO_CADASTRAL'
}
